var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order_detail" },
    [
      _c("div", { staticClass: "order_head" }, [
        _c("div", { staticClass: "order_head_title flex" }, [
          _c(
            "div",
            {
              staticClass: "page_title",
              staticStyle: { width: "1%", "margin-right": "30px" }
            },
            [
              _c("custom-breadcrumb", {
                attrs: { suffix: "Invoice NO. " + _vm.orderId }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page_button" },
            [
              _vm.orderStatus == "Unpaid" || _vm.orderStatus == "Failed"
                ? _c(
                    "el-button",
                    {
                      staticClass: "creat_button orange_background",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toCopyInfo(_vm.orderId)
                        }
                      }
                    },
                    [_vm._v("Send Order Link\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.orderStatus == "Unpaid" || _vm.orderStatus == "Failed"
                ? _c(
                    "el-button",
                    {
                      staticClass: "creat_button",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.changeOrderButton(_vm.orderId, 2, "Cancel")
                        }
                      }
                    },
                    [_vm._v("Cancel\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.orderStatus == "Paid"
                ? _c(
                    "el-button",
                    {
                      staticClass: "creat_button",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.changeOrderButton(
                            _vm.orderId,
                            40,
                            "Accept"
                          )
                        }
                      }
                    },
                    [_vm._v("Accept\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.brandShippingModel === "2" &&
              _vm.orderStatus == "Packaging" &&
              _vm.tsStoreOrderInfo["isProceedShipmented"] != null &&
                _vm.tsStoreOrderInfo["isProceedShipmented"]
                ? _c(
                    "el-button",
                    {
                      staticClass: "creat_button",
                      attrs: { type: "primary" },
                      on: { click: _vm.gotoShipped }
                    },
                    [_vm._v("Shipped\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.orderStatus == "Packaging" ||
              _vm.orderStatus == "Shipped" ||
              _vm.orderStatus == "Received" ||
              _vm.orderStatus == "Partial Shipped"
                ? _c(
                    "el-button",
                    {
                      staticClass: "creat_button",
                      attrs: { type: "primary" },
                      on: { click: _vm.gotoShippingInvoice }
                    },
                    [_vm._v("Preview Invoice\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.isOperationAccount || _vm.supplierManagementModelFlag) &&
              (_vm.tsStoreOrderInfo.orderStatus == 40 ||
                _vm.tsStoreOrderInfo.orderStatus == 4)
                ? [
                    _vm.tsStoreOrderInfo.orderStatus == 40 &&
                    _vm.tsStoreOrderInfo["type"] !== 6 &&
                    _vm.tsStoreOrderInfo["type"] !== 1 &&
                    !_vm.tsStoreOrderInfo["isRefuseFulfill"] &&
                    !_vm.tsStoreOrderInfo["isProceedShipmented"] &&
                    (!_vm.tsStoreOrderInfo["isMarkNonwares"] ||
                      (_vm.tsStoreOrderInfo["isMarkNonwares"] &&
                        _vm.tsStoreOrderInfo["isNonwaresRetailerAgree"])) &&
                    !_vm.tsStoreOrderInfo["isExistServiceOrder"]
                      ? _c(
                          "el-button",
                          {
                            staticClass: "action_button action_button2",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.$refs.outStackDialog.show(
                                  true,
                                  _vm.orderId
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            Proceed the shipment\n          "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tsStoreOrderInfo["isShowEditItem"]
                      ? _c(
                          "el-button",
                          {
                            staticClass: "action_button action_button2",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.$router.push({
                                  path: "edit-item-avaliability",
                                  query: {
                                    orderId: _vm.orderId,
                                    userSource: _vm.$route.query.userSource
                                  }
                                })
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            Edit Item Availability\n          "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tsStoreOrderInfo.orderStatus == 40 &&
                    _vm.tsStoreOrderInfo["type"] !== 6 &&
                    _vm.tsStoreOrderInfo["type"] !== 1 &&
                    !_vm.tsStoreOrderInfo["isRefuseFulfill"] &&
                    !_vm.tsStoreOrderInfo["isProceedShipmented"] &&
                    !_vm.tsStoreOrderInfo["isMarkNonwares"] &&
                    !_vm.tsStoreOrderInfo["isExistServiceOrder"]
                      ? _c(
                          "el-button",
                          {
                            staticClass: "action_button action_button2",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.$refs.outStackDialog.show(
                                  false,
                                  _vm.orderId
                                )
                              }
                            }
                          },
                          [_vm._v("\n            Reject order\n          ")]
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isVidirect && _vm.supplierManagementModel !== 2
                ? _c(
                    "el-button",
                    {
                      staticStyle: {
                        width: "100px",
                        height: "40px",
                        background: "#000000",
                        color: "#ffffff"
                      },
                      attrs: { type: "primary" },
                      on: { click: _vm.invoice }
                    },
                    [_vm._v("\n          Invoice\n        ")]
                  )
                : _vm._e()
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "order_nav flex" }, [
          _c("div", { staticClass: "nav_msg flex" }, [
            _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Order total")]),
            _vm._v(" "),
            _c("p", { staticClass: "nac_msg_num" }, [
              _vm._v(_vm._s(_vm.totalInfo.payAmount))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav_msg flex" }, [
            _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Orders Date")]),
            _vm._v(" "),
            _c("p", { staticClass: "nac_msg_num" }, [
              _vm._v(_vm._s(_vm.orderDate))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav_msg flex" }, [
            _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Orders Status")]),
            _vm._v(" "),
            _c("p", { staticClass: "nac_msg_num" }, [
              _vm._v(_vm._s(_vm.orderStatus))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav_msg flex address_width" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav_msg flex", staticStyle: { width: "20%" } },
            [
              _c("p", { staticClass: "nac_msg_name no_border" }, [
                _vm._v("Customer")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "nac_msg_num no_border" }, [
                _vm._v(_vm._s(_vm.customer))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _vm.tsStoreOrderInfo.orderStatus == 40
          ? _c(
              "p",
              {
                staticStyle: {
                  color: "#FB541C",
                  "font-size": "14px",
                  margin: "20px 20px"
                }
              },
              [
                _vm.tsStoreOrderInfo["isMarkNonwares"] &&
                _vm.tsStoreOrderInfo["isNonwaresRetailerAgree"] == null
                  ? _c("span", [
                      _vm._v(
                        "\n              The order has out of stock items, waiting for confirmation from the retailer\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.tsStoreOrderInfo["isMarkNonwares"] &&
                _vm.tsStoreOrderInfo["isNonwaresRetailerAgree"]
                  ? _c("span", [
                      _vm._v(
                        "\n          Confirmed by the retailer, please check that the remaining items are not out of stock and ship all at once\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.tsStoreOrderInfo["isMarkNonwares"] &&
                _vm.tsStoreOrderInfo["isNonwaresRetailerAgree"] != null &&
                  !_vm.tsStoreOrderInfo["isNonwaresRetailerAgree"]
                  ? _c("span", [
                      _vm._v(
                        "\n              The retailer refuses to ship the remaining goods and has generated an after sale order\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.tsStoreOrderInfo["isRefuseFulfill"]
                  ? _c("span", [
                      _vm._v(
                        "The order was rejected by the brand:" +
                          _vm._s(_vm.tsStoreOrderInfo["refuseFulfillReason"])
                      )
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "order_tracking_information" },
        [
          _vm.orderLogisticsSelfDelivery && _vm.orderLogisticsSelfDelivery.id
            ? _c("div", { staticClass: "order_tracking_information_header" }, [
                _c(
                  "div",
                  {
                    staticClass: "order_tracking_information_header_action",
                    on: { click: _vm.gotoTracking }
                  },
                  [_vm._v("Tracking info")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "order_tracking_information_header_action",
                    on: { click: _vm.gotoShipped }
                  },
                  [_vm._v("Edit Tracking")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.orderLogisticsSelfDelivery && _vm.orderLogisticsSelfDelivery.id
            ? _c("el-divider")
            : _vm._e(),
          _vm._v(" "),
          _vm.orderLogisticsSelfDelivery && _vm.orderLogisticsSelfDelivery.id
            ? _c("div", { staticClass: "order_tracking_information_main" }, [
                _c(
                  "div",
                  {
                    staticClass: "order_tracking_information_main_tracknumber"
                  },
                  [
                    _vm._v("Tracking Number:"),
                    _c("span", [
                      _vm._v(_vm._s(_vm.orderLogisticsSelfDelivery.logisticsNo))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "order_tracking_information_main_carrier" },
                  [
                    _vm._v("Shipping Carrier:"),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.orderLogisticsSelfDelivery.shippingCarrierName
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "order_tracking_information_main_invoice",
                    on: { click: _vm.viewInvoiceFile }
                  },
                  [_vm._v("Shipping invoice file")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.orderLogisticsSelfDelivery && _vm.orderLogisticsSelfDelivery.id
            ? _c("el-divider")
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "order_main" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.skuList }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "Item", width: "420" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "prduct_box" }, [
                              _c("img", {
                                staticClass: "product_img",
                                attrs: { src: scope.row.skuImg, alt: "" }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "product_info" }, [
                                _c("p", { staticClass: "product_name" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(scope.row.skuName) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "product_size" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(scope.row["finalSkuName"]) +
                                      "\n                  "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#8F8F8F",
                                        "margin-left": "15px",
                                        "font-size": "14px"
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(scope.row["skuCode"]))]
                                  )
                                ]),
                                _vm._v(" "),
                                scope.row["skuStatus"] == "0" &&
                                (_vm.tsStoreOrderInfo["isMarkNonwares"] ||
                                  _vm.tsStoreOrderInfo["isRefuseFulfill"])
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "mark-error",
                                        staticStyle: { height: "40px" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  This item is temporarily out of stock, " +
                                            _vm._s(
                                              scope.row["serviceOrderWaitNum"]
                                            ) +
                                            " items can be shipped\n                  "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "5px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "Restock Date: " +
                                                _vm._s(
                                                  scope.row["skuRestockDate"]
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row["skuStatus"] == "2" &&
                                (_vm.tsStoreOrderInfo["isMarkNonwares"] ||
                                  _vm.tsStoreOrderInfo["isRefuseFulfill"])
                                  ? _c("div", { staticClass: "mark-error" }, [
                                      _vm._v(
                                        "\n                  This item is sold out，" +
                                          _vm._s(
                                            scope.row["serviceOrderWaitNum"]
                                          ) +
                                          " items can be shipped\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.supplierManagementModel === 2
                    ? _c("el-table-column", {
                        attrs: { label: "Cost Price", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "prduct_box flex" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("fixed2")(
                                              scope.row["sourcePrice"]
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1011010800
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.supplierManagementModelFlag &&
                  _vm.supplierManagementModel != 2
                    ? _c("el-table-column", {
                        attrs: { label: "FOB Price", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "prduct_box flex" },
                                    [
                                      (_vm.orderStatus == "Unpaid" ||
                                        _vm.orderStatus == "Failed") &&
                                      _vm.tsStoreOrderInfo["type"] !== 7
                                        ? _c("el-input", {
                                            staticClass: "price_input",
                                            attrs: {
                                              placeholder: "FOB Price",
                                              oninput:
                                                "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}"
                                            },
                                            on: {
                                              change: function(event) {
                                                return _vm.blurFob(
                                                  event,
                                                  scope.$index,
                                                  scope["row"]
                                                )
                                              }
                                            },
                                            model: {
                                              value: scope.row["fobPriceFinal"],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "fobPriceFinal",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row['fobPriceFinal']"
                                            }
                                          })
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("fixed2")(
                                                  scope.row["fobPriceFinal"]
                                                )
                                              )
                                            )
                                          ]),
                                      _vm._v(" "),
                                      scope.row["fobPriceFinalBefore"] !=
                                      scope.row["fobPriceFinal"]
                                        ? _c(
                                            "div",
                                            {
                                              class:
                                                scope.row[
                                                  "fobPriceFinalBefore"
                                                ] != scope.row["fobPriceFinal"]
                                                  ? "dis_price dis_line"
                                                  : "dis_price"
                                            },
                                            [
                                              _vm._v(
                                                "\n                $" +
                                                  _vm._s(
                                                    scope.row[
                                                      "fobPriceFinalBefore"
                                                    ]
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2435025324
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.supplierManagementModel != 2
                    ? _c("el-table-column", {
                        attrs: { label: "Wholesale Price", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "prduct_box flex" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm._f("fixed2")(
                                              scope.row.unitPrice
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                      scope.row["unitPrice"] !=
                                      scope.row["unitPriceBeforeDiscount"]
                                        ? _c(
                                            "div",
                                            {
                                              class:
                                                scope.row["unitPrice"] !=
                                                scope.row[
                                                  "unitPriceBeforeDiscount"
                                                ]
                                                  ? "dis_price dis_line"
                                                  : "dis_price"
                                            },
                                            [
                                              _vm._v(
                                                "\n                $" +
                                                  _vm._s(
                                                    scope.row[
                                                      "unitPriceBeforeDiscount"
                                                    ]
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          685229525
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Qty", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "prduct_box flex qty-left" },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(Number(scope.row["num"])))
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Total" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "flex total_amount" }, [
                              _vm.supplierManagementModel === 2
                                ? _c("span", [
                                    _vm._v(
                                      "$" +
                                        _vm._s(
                                          _vm._f("fixed2")(
                                            Number(scope.row["sourcePrice"]) *
                                              Number(scope.row["num"])
                                          )
                                        )
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "$" +
                                        _vm._s(
                                          _vm._f("fixed2")(
                                            Number(
                                              !scope.row["isSkuChangePrice"]
                                                ? scope.row["unitPrice"]
                                                : scope.row[
                                                    "unitPriceBeforeDiscount"
                                                  ]
                                            ) * Number(scope.row["num"])
                                          )
                                        )
                                    )
                                  ])
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.orderStatus !== "Unpaid" && _vm.orderStatus !== "Failed"
                    ? _c("el-table-column", {
                        attrs: { label: "Item Status" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  !scope.row["serviceOrderStatus"] ||
                                  scope.row["serviceOrderStatus"] == 1
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("skuStatusFilter")(
                                              scope.row.orderStatus
                                            )
                                          )
                                        )
                                      ])
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#FF4812",
                                            "text-decoration": "underline",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.gotoServiceOrders(
                                                scope.row.uid
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                scope.row[
                                                  "serviceOrderStatus"
                                                ] == 2
                                                  ? "In-Service"
                                                  : "Refunded"
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2968220681
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "order_footer" }, [
        _c("div", { staticClass: "footer_title" }, [
          _vm._v("\n      Payment method "),
          _c("span", { staticClass: "footer_subtitle" }, [
            _vm._v(_vm._s(_vm.paymentMethod))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "memo" }, [
            _vm._v("\n        Memo\n        "),
            _c("img", {
              attrs: { src: require("@/assets/img/memo.png"), alt: "" },
              on: { click: _vm.editMemo }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.tsStoreOrderInfo.memo))])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "end_box flex" },
          [
            _c("div", { staticClass: "creat_text flex" }, [
              _c("p", [_vm._v(_vm._s(_vm.tsStoreOrderInfo["brandName"]))]),
              _vm._v(" "),
              _vm.supplierManagementModel !== 2
                ? _c("p", [
                    _vm._v(
                      "$" +
                        _vm._s(_vm._f("fixed2")(_vm.totalInfo["cifSubTotal"]))
                    )
                  ])
                : _c("p", [
                    _vm._v(
                      "$" +
                        _vm._s(
                          _vm._f("fixed2")(_vm.totalInfo["sourcePriceTotal"])
                        )
                    )
                  ])
            ]),
            _vm._v(" "),
            _vm.supplierManagementModel !== 2
              ? _c("div", { staticClass: "creat_text flex" }, [
                  _c("p"),
                  _vm._v(" "),
                  _c("p", { staticStyle: { color: "#5D5D5D" } }, [
                    _vm._v(
                      "(FOB Subtotal $" +
                        _vm._s(_vm._f("fixed2")(_vm.totalInfo["fobSubtotal"])) +
                        ")"
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.supplierManagementModel !== 2
              ? _c("div", { staticClass: "creat_text flex" }, [
                  _c("p", { staticClass: "brown_text" }, [
                    _vm._v("Product discount")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "brown_text" }, [
                    _c("span", { staticClass: "black_text" }, [_vm._v("-")]),
                    _vm._v(
                      "$" +
                        _vm._s(
                          _vm._f("fixed2")(
                            _vm.totalInfo["totalPriceProductDicounted"]
                          )
                        ) +
                        "\n        "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "creat_text flex" }, [
              _c("p", { staticClass: "brown_text" }, [
                _vm._v("Bulk order discount")
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "brown_text" },
                [
                  _c("span", { staticClass: "black_text" }, [_vm._v("-$")]),
                  _vm._v(" "),
                  _vm.orderStatus == "Unpaid" || _vm.orderStatus == "Failed"
                    ? _c("el-input", {
                        staticClass: "price_input brown_text",
                        attrs: {
                          oninput:
                            "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}",
                          placeholder: "",
                          clearable: ""
                        },
                        on: { change: _vm.changePrice },
                        model: {
                          value: _vm.totalInfo["totalPriceOrderDiscounted"],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.totalInfo,
                              "totalPriceOrderDiscounted",
                              $$v
                            )
                          },
                          expression: "totalInfo['totalPriceOrderDiscounted']"
                        }
                      })
                    : _c("span", [
                        _vm._v(
                          _vm._s(_vm.totalInfo["totalPriceOrderDiscounted"])
                        )
                      ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.totalInfo["totalPriceOrderDiscountedShopvidi"]
              ? _c("div", { staticClass: "creat_text flex" }, [
                  _c("p", { staticClass: "brown_text" }, [
                    _vm._v("Offered by ShopVidi")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "brown_text" }, [
                    _c("span", { staticClass: "black_text" }, [_vm._v("-$")]),
                    _vm._v(" "),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm._f("fixed2")(
                            _vm.totalInfo["totalPriceOrderDiscountedShopvidi"]
                          )
                        ) +
                        "\n        "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "creat_text flex",
                staticStyle: { "font-weight": "600" }
              },
              [
                _c("p", [_vm._v("Subtotal")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "$" + _vm._s(_vm._f("fixed2")(_vm.totalInfo["subTotal"]))
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "creat_text flex" }, [
              _c("p", [_vm._v("Shipping")]),
              _vm._v(" "),
              _c("p", [
                _vm._v("+$" + _vm._s(_vm.totalInfo["totalFreightBefore"]))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "creat_text flex" }, [
              _c("p", [
                _vm._v(
                  "Shipping Disc (By\n          " +
                    _vm._s(
                      this.tsStoreOrderInfo["logisticUnderwriter"] ||
                        _vm.brandShippingModel === "1"
                        ? "ShopVidi"
                        : "Brand"
                    ) +
                    ")"
                )
              ]),
              _vm._v(" "),
              ((_vm.orderStatus == "Unpaid" || _vm.orderStatus == "Failed") &&
                this.tsStoreOrderInfo["type"] !== 7 &&
                  !_vm.isShippingFree &&
                  !this.tsStoreOrderInfo["logisticUnderwriter"] &&
                  ((this.supplierManagementModelFlag &&
                    this.brandShippingModel === "2") ||
                    (_vm.isOperationAccount &&
                      this.brandShippingModel === "1"))) ||
              (this.tsStoreOrderInfo["type"] === 7 &&
                (_vm.isOperationAccount ||
                  (!_vm.isShippingFree &&
                    !this.tsStoreOrderInfo["logisticUnderwriter"] &&
                    ((this.supplierManagementModelFlag &&
                      this.brandShippingModel === "2") ||
                      (_vm.isOperationAccount &&
                        this.brandShippingModel === "1")))))
                ? _c(
                    "p",
                    [
                      _c("span", { staticClass: "black_text" }, [_vm._v("-$")]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "price_input brown_text",
                        attrs: {
                          disabled: _vm.disabled,
                          oninput:
                            "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}",
                          placeholder: ""
                        },
                        on: { change: _vm.changeTotalFreight },
                        model: {
                          value: _vm.totalInfo["totalFreightDiscounted"],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.totalInfo,
                              "totalFreightDiscounted",
                              $$v
                            )
                          },
                          expression: "totalInfo['totalFreightDiscounted']"
                        }
                      })
                    ],
                    1
                  )
                : _c("p", [
                    _vm._v(
                      "\n          -$" +
                        _vm._s(_vm.totalInfo["totalFreightDiscounted"]) +
                        "\n        "
                    )
                  ])
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "creat_text blod_text flex" }, [
              _c("p", [_vm._v("Total Amount")]),
              _vm._v(" "),
              _c("p", { staticClass: "amount_text" }, [
                _vm._v(
                  "$" + _vm._s(_vm._f("fixed2")(_vm.totalInfo["payAmount"]))
                )
              ])
            ]),
            _vm._v(" "),
            _vm.orderStatus == "Unpaid" || _vm.orderStatus == "Failed"
              ? _c(
                  "el-button",
                  {
                    staticClass: "add-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.editOrder()
                      }
                    }
                  },
                  [_vm._v("Submit\n      ")]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("Address", {
              ref: "address",
              attrs: { addressMessage: _vm.addressMessage }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("edit-memo", {
        ref: "memo",
        attrs: { message: _vm.tsStoreOrderInfo }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.acceptVisible, width: "30%" },
          on: {
            "update:visible": function($event) {
              _vm.acceptVisible = $event
            },
            close: function($event) {
              _vm.acceptVisible = false
            }
          }
        },
        [
          _c("span", { staticClass: "back_icon" }, [
            _c("i", { staticClass: "el-icon-arrow-left" }),
            _vm._v("Back")
          ]),
          _vm._v(" "),
          _vm.changeOrderNum == 40
            ? _c("p", { staticClass: "success_text" }, [
                _vm._v(
                  "\n      Please review the Item availability before shipping orders\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.changeOrderNum == 2
            ? _c("p", { staticClass: "success_text" }, [
                _vm._v(
                  "\n      Are you sure you want to cancel the order?\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.changeOrderNum == 5
            ? _c("p", { staticClass: "success_text" }, [
                _vm._v(
                  "\n      Please confirm that your order has been shipped\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer flex_all",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.acceptVisible = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "confirm_button",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.confirmOrderStatus()
                    }
                  }
                },
                [_vm._v("Confirm")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.copyVisible, width: "30%" },
          on: {
            "update:visible": function($event) {
              _vm.copyVisible = $event
            },
            close: function($event) {
              _vm.copyVisible = false
              _vm.copyEdit = false
            }
          }
        },
        [
          _c("span", { staticClass: "back_icon" }, [
            _c("i", { staticClass: "el-icon-arrow-left" }),
            _vm._v("Send Order Link")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "border_box" }, [
            _c("p", { staticClass: "copy_title" }, [_vm._v("your order link")]),
            _vm._v(" "),
            _c("p", { staticClass: "copy_subtitle" }, [
              _vm._v(
                "\n        https://www.shopvidi.com/whosalesDetails/" +
                  _vm._s(_vm.rowOrderID) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "copy_title" }, [
              _vm._v("ShopVidi Account")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "copy_subtitle" }, [
              _vm._v(_vm._s(_vm.nowretailerName))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex_all" },
            [
              _c(
                "el-button",
                {
                  staticClass: "back_button",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.copyLink($event)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-paperclip" }),
                  _vm._v(_vm._s(_vm.copyEdit ? "Copied" : "Copy") + "\n      ")
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.successVisible,
            "close-on-click-modal": false,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.successVisible = $event
            },
            close: function($event) {
              return _vm.backOrderList()
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "back_icon",
              on: {
                click: function($event) {
                  return _vm.backOrderList()
                }
              }
            },
            [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("Back")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "success_text" }, [
            _vm._v("Order modified successfully")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex_all" },
            [
              _c(
                "el-button",
                {
                  staticClass: "back_button",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.backOrderList()
                    }
                  }
                },
                [
                  _vm._v(
                    "Back Order List (" + _vm._s(_vm.seconds) + ")\n      "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("out-stock", { ref: "outStackDialog" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "creat_text flex" }, [
      _c("div", { staticClass: "split" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "creat_text flex" }, [
      _c("div", { staticClass: "split" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7001d9ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7001d9ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/orderDetail.vue
// module id = /otf
// module chunks = 2